import {Injectable, inject} from '@angular/core'
import type {ActivatedRouteSnapshot} from '@angular/router'
import {AppNewsService} from '../app-news.service'
import {ConversationOrganizationService} from '../conversation-organization.service'
import {NavigationService} from '../navigation.service'
import {SigninService} from '../signin.service'
import {StorageService} from '../storage.service'

@Injectable({
  providedIn: 'root',
})
export class AuthOrInitGuard {
  readonly #conversationOrganizationService = inject(ConversationOrganizationService)
  readonly #storageService = inject(StorageService)
  readonly #navigationService = inject(NavigationService)
  readonly #appNewsService = inject(AppNewsService)
  readonly #signinService = inject(SigninService)

  async canActivate(route: ActivatedRouteSnapshot) {
    const hasToRedirectAppNews: boolean = await this.#appNewsService.hasToRedirectAppNews()
    if (hasToRedirectAppNews) {
      this.#navigationService.navigateRoot('app-news')
      return false
    }

    if (!this.#signinService.isAuthenticated()) {
      await this.#conversationOrganizationService.initConversationContactAndNavigate(route.queryParams)
      if (!this.#signinService.isAuthenticated()) {
        this.#storageService.reloadApp = true
        this.#navigationService.navigateRoot('auth')
        return false
      }
    }

    return true
  }
}
